"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Mobiledoc_1 = require("../../types/Mobiledoc");
var utils_1 = require("../../utils");
var TAG_NAME = Mobiledoc_1.ImageSectionTagName.img;
exports.default = (function (_a) {
    var createElement = _a.createElement, getMarkupComponent = _a.getMarkupComponent;
    return function (_a) {
        var src = _a[1];
        return createElement(getMarkupComponent(TAG_NAME) ||
            utils_1.throwError("Unhandled element: the image section tag name `'" + TAG_NAME + "'` has no corresponding handler."), { src: src });
    };
});
